module.exports = __webpack_public_path__ + "assets/messenger.159d2401.svg";